import type { FileItem } from "../api/client";
import { useLongPress } from "../hooks/useLongPress";
import { cx } from "../util/classnames";

type Props = {
  file: FileItem;
  selected?: boolean;
  selectMode?: boolean;
  onClick?: (file: FileItem) => void;
  onLongPress?: (file: FileItem) => void;
  rightOverlay?: JSX.Element | null;
};

export function ThumbnailTile({ file, selected, selectMode, onClick, onLongPress, rightOverlay }: Props) {
  const lp = useLongPress(() => onLongPress?.(file));
  const ready = file.thumbnail_ready;
  return (
    <button
      type="button"
      onClick={() => {
        if (lp.triggered.current) return;
        onClick?.(file);
      }}
      {...lp.handlers}
      className={cx(
        "group relative aspect-square overflow-hidden bg-ink/5",
        selected && "ring-4 ring-ink",
      )}
    >
      {ready ? (
        <img
          src={`/thumbs/${file.id}.jpg`}
          alt={file.original_name}
          loading="lazy"
          decoding="async"
          className="h-full w-full object-cover"
        />
      ) : (
        <div className="flex h-full w-full items-center justify-center text-xs text-ink/40">
          {file.media_type === "video" ? "video…" : "…"}
        </div>
      )}
      {file.media_type === "video" && (
        <span className="absolute bottom-1 left-1 rounded bg-black/70 px-1.5 py-0.5 text-[10px] font-medium text-white">
          ▶ video
        </span>
      )}
      {selectMode && (
        <span
          className={cx(
            "absolute right-2 top-2 grid h-6 w-6 place-items-center rounded-full border-2",
            selected ? "border-ink bg-ink text-white" : "border-white bg-black/30 text-transparent",
          )}
        >
          ✓
        </span>
      )}
      {rightOverlay}
    </button>
  );
}
